import { Typography } from "@lyfegen-platform/react-common";
import { Box, useTheme } from "@material-ui/core";

export function Badge(props: {
	name: string;
	isActive: boolean;
	color?: string;
	backgroundColor?: string;
	icon?: () => JSX.Element;
	isActiveContent?: boolean;
}) {
	const { palette } = useTheme();

	return (
		<Box
			height="22px"
			px={1}
			mr={0.5}
			display="flex"
			alignItems="center"
			style={{
				backgroundColor: props.backgroundColor,
				borderRadius: "0.75rem",
				border: `1px solid ${props.isActive && !props.isActiveContent ? palette.primary.main : props.backgroundColor || "#cddcdc"}`,
				width: "fit-content",
			}}
		>
			{props.icon?.()}
			<Typography type={props.icon ? "status" : "regular"} style={{ paddingLeft: 5, color: props.color, whiteSpace: "nowrap" }}>
				{props.name}
			</Typography>
		</Box>
	);
}
